import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';
import b from 'b_';
import FlagStore from '../../stores/FlagStore';
import BoolStore from '../../stores/helpers/BoolStore';
import { FTLabel } from '../Fuse';
import FuseInfoTooltip from './FuseTooltip/FuseInfoTooltip';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import './FuseSwitch.css';
import './FuseSwitch.new.css';

let block = b.lock('FuseSwitch');
const newblock = b.lock('Fuse5FuseSwitch');

class FuseSwitch extends Component {
    static propTypes = {
        readOnly: PropTypes.bool,
        disabled: PropTypes.bool,
        focus: PropTypes.bool,
        hover: PropTypes.bool,
        active: PropTypes.bool,
        headerInfoPosition: PropTypes.string,
        store: PropTypes.oneOfType([FlagStore.PropType.isRequired, BoolStore.PropTypes.isRequired]),
        label: PropTypes.string,
        header: PropTypes.node,
        headerInfo: PropTypes.string,
        onToggleChange: PropTypes.func,
        qa: PropTypes.string,
        inverted: PropTypes.bool // If true, the switch will be checked when the store value is false
    };

    state = {
        focus: false,
    };

    constructor(props) {
        super(props);
        block = isFuse5Enabled() ? newblock : block;
    }

    // Safely get the raw value from the store, supporting both FlagStore (with dirty tracking)
    // and ValueStore/BoolStore (without dirty tracking)
    getRawValue = () => (this.props.store?.isTrackingDirty?.() && this.props.store?.getDirtyValue
        ? this.props.store.getDirtyValue()
        : this.props.store.getValue());

    onClick = (e) => {
        if (e.pageX !== 0 && e.pageY !== 0) {
            this.setState({ focus: false });
        }
    };

    onChange = () => {
        const { store } = this.props;
        store.toggle();
        if (this.props.onToggleChange) {
            const rawValue = this.getRawValue();
            // Apply inversion if needed
            const currentValue = this.props.inverted ? !rawValue : rawValue;
            this.props.onToggleChange(currentValue);
        }
    };

    render() {
        const {
            store,
            label,
            className,
            readOnly,
            disabled,
            focus,
            hover,
            active,
            header,
            headerInfo,
            headerInfoPosition,
            onToggleChange,//eslint-disable-line
            qa,
            inverted,
            ...inputProps
        } = this.props;

        const rawValue = this.getRawValue();
        // Apply inversion if needed
        const currentValue = inverted ? !rawValue : rawValue;

        return <div className={className}>
            <label
                className={cn(block({
                    checked: currentValue,
                    disabled: readOnly || disabled,
                    hover: hover === true,
                    active: active === true,
                    focused: focus === undefined ? this.state.focus : focus,
                }))}
                {...qa ? { 'data-qa': qa } : {}}
            >
                {header ? <div className={block('Header')}>
                    <FTLabel>{header}</FTLabel>
                    {headerInfo ? <FuseInfoTooltip position={headerInfoPosition}>{headerInfo}</FuseInfoTooltip> : null}
                </div> : null}

                <div className={block('SwitchContainer')}>
                    <input
                        className={block('Input')}
                        type="checkbox"
                        disabled={readOnly || disabled}
                        checked={currentValue}
                        onChange={this.onChange}
                        onClick={this.onClick}
                        onFocus={() => this.setState({ focus: true })}
                        onBlur={() => this.setState({ focus: false })}
                        {...qa ? { 'data-qa': `${qa}-input` } : {}}
                        {...inputProps}
                    />
                    <div className={block('Track')}>
                        <div className={block('ThumbUnderlay')} />
                    </div>
                    <div className={block('Text', { disabled, readOnly })}>{label}</div>
                </div>
            </label>
        </div>;
    }
}

export default observer(FuseSwitch);
